if (!customElements.get('product-card-slider')) {
  customElements.define(
    'product-card-slider',
    class ProductCardSlider extends HTMLElement {
      connectedCallback() {
        this.sliderInstance = null;
        this.paginationEl = this.querySelector('.swiper-pagination');
        this.slideCount = this.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
        this.controller = new AbortController();
        const listenerOptions = { signal: this.controller.signal };
        this.paginationEl?.addEventListener('click', (event) => this.onPaginationInteraction(event), listenerOptions);
        this.paginationEl?.addEventListener('keydown', (event) => this.onPaginationInteraction(event), listenerOptions);

        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.updateViewport = () => {
          if (this.mobileQuery.matches) this.initSlider();
          else this.destroySlider();
        };
        this.mobileQuery.addEventListener('change', this.updateViewport, listenerOptions);
        this.updateViewport();
        if (!window.FoxTheme?.Carousel) {
          document.addEventListener('DOMContentLoaded', this.updateViewport, { once: true, ...listenerOptions });
        }
      }

      initSlider() {
        if (this.sliderInstance || !this.slideCount || !window.FoxTheme?.Carousel) return;

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: false,
          pagination: this.paginationEl ? {
            el: this.querySelector('.swiper-pagination'),
            type: 'custom',
            renderCustom: (swiper) => this.renderDots(swiper),
          } : false,
          loop: this.slideCount > 1,
          watchOverflow: true,
          threshold: 2,
        };

        this.classList.add('swiper');
        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
      }

      renderDots(swiper) {
        if (this.slideCount <= 1) return '';
        const current = Math.max(0, Math.min(Number(swiper.realIndex) || 0, this.slideCount - 1));
        const visibleCount = Math.min(3, this.slideCount);
        const start = Math.min(Math.max(current - 1, 0), this.slideCount - visibleCount);
        let dots = '';
        for (let index = start; index < start + visibleCount; index++) {
          const active = index === current;
          dots += `<span class="swiper-pagination-bullet${active ? ' swiper-pagination-bullet-active' : ''}" data-image-index="${index}" role="button" tabindex="0" aria-label="Image ${index + 1} of ${this.slideCount}"${active ? ' aria-current="true"' : ''}></span>`;
        }
        return dots;
      }

      onPaginationInteraction(event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        const dot = event.target.closest('[data-image-index]');
        const swiper = this.sliderInstance?.slider;
        if (!dot || !this.paginationEl.contains(dot) || !swiper) return;
        const index = Number(dot.dataset.imageIndex);
        if (!Number.isInteger(index) || index < 0 || index >= this.slideCount) return;
        // Pagination lives inside the product link; selecting an image must not navigate away.
        event.preventDefault();
        event.stopPropagation();
        if (swiper.params.loop) swiper.slideToLoop(index);
        else swiper.slideTo(index);
        if (event.type === 'keydown') {
          cancelAnimationFrame(this.focusFrame);
          this.focusFrame = requestAnimationFrame(() => {
            if (this.isConnected) {
              this.paginationEl.querySelector('[aria-current="true"]')?.focus({ preventScroll: true });
            }
          });
        }
      }

      destroySlider() {
        this.sliderInstance?.slider?.destroy(true, true);
        this.sliderInstance = null;
      }

      disconnectedCallback() {
        this.controller?.abort();
        cancelAnimationFrame(this.focusFrame);
        this.destroySlider();
      }
    }
  );
}
